import styled from 'styled-components';
import {dFlex, dFlexEnd} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const actionsRow = styled.div`
    ${dFlex};
    gap: var(--space-md);
    width: 100%;
    padding-bottom: var(--space-sm);
    ${dFlexEnd};
`;

export const actionButton = styled.div<{isFullWidth: boolean}>`
    flex: ${p => p.isFullWidth ? 1 : 0};
    button {
        width: ${p => p.isFullWidth ? '100%' : 'auto'};
        ${mobileMedia} {
            width: 100%;
        }
    }
`;
